module.exports = __webpack_public_path__ + "img/electronic_no_zone.89a75269.svg";